import React from 'react';

const CustomerContact = React.lazy(() => import('pages/CustomerContact/pages/CustomerContactPage'));
const CustomerContactAdd = React.lazy(() => import('pages/CustomerContact/pages/CustomerContactAdd'));
const CustomerContactEdit = React.lazy(() => import('pages/CustomerContact/pages/CustomerContactEdit'));
const CustomerContactDetail = React.lazy(() => import('pages/CustomerContact/pages/CustomerContactDetail'));

const CustomerContactRoute = [
  {
    path: '/customer-contact',
    exact: true,
    name: 'Quản Lý Liên Hệ',
    function: 'SL_CUSTOMER_CONTACT_VIEW',
    component: CustomerContact,
  },
  {
    path: '/customer-contact/add',
    exact: true,
    name: 'Thêm mới liên hệ',
    function: 'SL_CUSTOMER_CONTACT_ADD',
    component: CustomerContactAdd,
  },
  {
    path: '/customer-contact/edit/:id',
    exact: true,
    name: 'Chỉnh sửa liên hệ',
    function: 'SL_CUSTOMER_CONTACT_EDIT',
    component: CustomerContactEdit,
  },
  {
    path: '/customer-contact/detail/:id',
    exact: true,
    name: 'Chi tiết liên hệ',
    function: 'SL_CUSTOMER_CONTACT_DETAIL',
    component: CustomerContactDetail,
  },
];

export default CustomerContactRoute;
